var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H12.75V3H2.25C1.425 3 0.75 3.675 0.75 4.5V12.75H2.25C2.25 13.995 3.255 15 4.5 15C5.745 15 6.75 13.995 6.75 12.75H11.25C11.25 13.995 12.255 15 13.5 15C14.745 15 15.75 13.995 15.75 12.75H17.25V9L15 6ZM14.625 7.125L16.095 9H12.75V7.125H14.625ZM4.5 13.5C4.0875 13.5 3.75 13.1625 3.75 12.75C3.75 12.3375 4.0875 12 4.5 12C4.9125 12 5.25 12.3375 5.25 12.75C5.25 13.1625 4.9125 13.5 4.5 13.5ZM6.165 11.25C5.7525 10.7925 5.1675 10.5 4.5 10.5C3.8325 10.5 3.2475 10.7925 2.835 11.25H2.25V4.5H11.25V11.25H6.165ZM13.5 13.5C13.0875 13.5 12.75 13.1625 12.75 12.75C12.75 12.3375 13.0875 12 13.5 12C13.9125 12 14.25 12.3375 14.25 12.75C14.25 13.1625 13.9125 13.5 13.5 13.5Z",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingCost);
export default __webpack_public_path__ + "static/media/Shipping_Cost.dfd2b9fd9bbb08fb0fa30ec94d2aab7a.svg";
export { ForwardRef as ReactComponent };